import { render, staticRenderFns } from "./modelOne.vue?vue&type=template&id=3cc7512d&scoped=true&"
import script from "./modelOne.vue?vue&type=script&lang=js&"
export * from "./modelOne.vue?vue&type=script&lang=js&"
import style0 from "./modelOne.vue?vue&type=style&index=0&id=3cc7512d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc7512d",
  null
  
)

export default component.exports